import Rollbar from "rollbar"
import rollbarConfig from "../configs/rollbarConfig"

export const handleCsvDownload = async (url, fileName, headers = {}) =>{
  const rollbar = new Rollbar(rollbarConfig())

  try{
    const response = await fetch(url, { headers })

    const blob = await response.blob()
    const blobUrl = window.URL.createObjectURL(blob)

    const a = document.createElement("a")
    a.href = blobUrl
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(blobUrl)

    return true
  } catch (err) {
    rollbar.error("An error occured while downloading csv")
    return false
  }
}